
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customNumberToWords',
    standalone: false
})
export class CustomNumberToWordsPipe implements PipeTransform {
  private units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  private teens = ['', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  private tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  transform(value: number): string {
    if (value === 0) {
      return 'zero';
    }

    return this.convertNumberToWords(value);
  }

  private convertNumberToWords(value: number): string {
    if (value < 10) {
      return this.units[value];
    } else if (value >= 11 && value <= 19) {
      return this.teens[value - 11];
    } else if (value % 10 === 0 && value < 100) {
      return this.tens[Math.floor(value / 10)];
    } else if (value < 100) {
      const tens = this.tens[Math.floor(value / 10)];
      const units = this.units[value % 10];
      return `${tens}-${units}`;
    } else {
      return value.toString();
    }
  }
}
